<template>
    <div class="text-left">
        <b-form-row>
            <b-col>
                <span class="title-display-label">Applicant: </span>
                <span class="title-display-content">
                    {{ applicantName }}
                </span>
            </b-col>
            <b-col>
                <span class="title-display-label">FICE: </span>
                <span class="title-display-content">
                    {{ applicantId }}
                </span>
            </b-col>
        </b-form-row>
        <b-form-row>
            <b-col>
                <span class="title-display-label">EYPR-Narrative ID: </span>
                <span class="title-display-content">
                    {{ eyprNarrativeId }}
                </span>
            </b-col>
        </b-form-row>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
// import { Arc } from '$Shared/@arc/vue-arc';

export default {
    name: 'EyprDataHeader',

    props: {
    },

    computed: {
        ...mapGetters({
            applicantNameFromFice: 'ref/ee/ficeName',
        }),

        ...mapState('eyprNarrative/form', {
            eyprNarrativeId: (state) => state.eypr_narrative_id,
            applicantId: (state) => state.applicant_id,
        }),

        applicantName() {
            return this.applicantNameFromFice(this.applicantId);
        }
    },

    methods: {
    }
};
</script>

<style lang="scss">
.title-display {
    font-size: 18px;
    color: #fafafa;
    background-color: #380064;
}

.title-display-label {
    font-weight: light;
    text-align: right;
}

.title-display-content {
    font-weight: bolder;
    text-align: left;
}
</style>
